/* eslint-disable */
export default {
  logging: '記錄中...',
  logCall: '記錄通話',
  editLog: '編輯記錄',
  select: '選擇相符的記錄',
  OnHold: '保留',
  Ringing: '響鈴',
  CallConnected: '通話已連線',
  unknownUser: '未知的使用者',
  unknownNumber: '匿名',
  unavailable: '無法接聽通話',
  viewDetails: '檢視詳細資訊',
  addEntity: '建立',
  addLog: '記錄',
  text: '文字',
  call: '通話',
  missedCall: '未接',
  inboundCall: '撥入',
  outboundCall: '撥出電話',
  answeredBy: '已由以下人員接聽',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
